import { useState, useRef, useEffect } from "react";
import image from "./campus.svg";
import { FormattedMessage } from "react-intl";
import {
  BottomButton,
  BottomButtonContainer,
} from "../../../elements/wrapper/bottomButton.wrapper.jsx";
import StandardCheckbox from "../../../elements/buttons/standardCheckbox.button.jsx";
import { getQueryParams } from "../../../../app/RouteWithSubRoutes";
import IntroImage from "../../introImage.component.jsx";
import StandardInstruction from "../../../elements/text/standardInstruction.component.jsx";
import StandardHeadline from "../../../elements/text/standardHeadline.text.jsx";
import { pageNames } from "../../../../reduxStore/reducers/main";

export default function Campus(props) {
  const [selectedCampusKeys, setSelectedCampusKey] = useState(
    props.campuses.map((c) => c.campusKey)
  );
  // const [selectedCampusKeys, setSelectedCampusKey] = useState([]);
  const campusSelectContainer = useRef(null);

  const toggleSelectCampusKey = (key) => {
    if (selectedCampusKeys.includes(key)) {
      setSelectedCampusKey(selectedCampusKeys.filter((s) => s !== key));
    } else {
      setSelectedCampusKey(selectedCampusKeys.concat(key));
    }
  };

  const onComplete = () => {
    if (!selectedCampusKeys.length) {
      campusSelectContainer.current.classList.add("shake");
      setTimeout(() => {
        campusSelectContainer.current.classList.remove("shake");
      }, 500);
      return;
    }
    // TODO: Das wird nochmal in useLoadCampuses.sideEffects nach dem beenden des intros gemacht.
    props.loadCampuses(selectedCampusKeys, props.userGroup);
    // props.setCampusKeys(selectedCampusKeys);
    props.history.push(
      `/${pageNames.intro}/${pageNames.selectLocation}/${getQueryParams()}`
    );
  };

  useEffect(() => {
    setSelectedCampusKey(props.campuses.map((c) => c.campusKey));
  }, [props.campuses]);

  useEffect(() => {
    if (props.skipCampusSelection)
      props.history.push(
        `/${pageNames.intro}/${pageNames.selectLocation}/${getQueryParams()}`
      );
  }, [props.skipCampusSelection]);

  return (
    <BottomButtonContainer
      buttons={[
        new BottomButton(
          () => props.history.goBack(),
          <FormattedMessage id={"search.buttonBack"} />,
          { className: "mr-3 normalButton--naked" }
        ),
        new BottomButton(onComplete, <FormattedMessage id="welcome.next" />, {
          disabled: !selectedCampusKeys.length,
          className: "normalButton--primary",
        }),
      ]}
    >
      <IntroImage fallbackImage={image} imageName={"campus.svg"} />
      <div className="general-padding-large-horizontally">
        <StandardHeadline className={"mb-2 mt-3"} type={"h2"}>
          <FormattedMessage id="welcome.campusSelectionTitle" />
        </StandardHeadline>
        <StandardInstruction className={"mb-4"} type={"p"}>
          <FormattedMessage id="welcome.campusSelectionText" />
        </StandardInstruction>

        <div ref={campusSelectContainer}>
          {props.campuses.map((c) => (
            <div
              key={c.campusKey}
              onClick={() => toggleSelectCampusKey(c.campusKey)}
              className="general-margin-bottom-large d-flex justify-content-between pl-3 pr-3"
            >
              <span>{c.name}</span>
              <StandardCheckbox
                checked={selectedCampusKeys.includes(c.campusKey)}
              />
            </div>
          ))}
        </div>
      </div>
    </BottomButtonContainer>
  );
}
